import { notify } from '@affine/component';
import { AffineOtherPageLayout } from '@affine/component/affine-other-page-layout';
// import { SignInPageContainer } from '@affine/component/auth-components';
// import { SignInPanel } from '@affine/core/components/sign-in';
import { SignInBackgroundArts } from '@affine/core/components/sign-in/background-arts';
import { LoginConfig } from '@affine/core/config/login';
import { AuthService } from '@affine/core/modules/cloud';
import { GlobalDialogService } from '@affine/core/modules/dialogs';
import { EventKeyMap, Tracker } from '@affine/core/utils/ga-tracking';
// import type { AuthSessionStatus } from '@affine/core/modules/cloud/entities/session';
import { useI18n } from '@affine/i18n';
import { useLiveData, useService } from '@toeverything/infra';
// import {
//   RouteLogic,
//   useNavigateHelper,
// } from '../../../components/hooks/use-navigate-helper';
import { LoginWrapper } from '@ys/repo-ui/biz/login';
import {
  // useCallback,
  useEffect,
  useState,
} from 'react';
import {
  //  useNavigate,
  useSearchParams,
} from 'react-router-dom';


function loginSuccessTrack( type: keyof typeof EventKeyMap, params: object) {
  return new Promise((resolve) => {
    Tracker.track(type, {
      ...params,
      event_callback: () => {
        resolve(true);
      },
    });
    setTimeout(() => {
      resolve(true);
    }, 2000);
  });
}

export const SignIn = ({
  redirectUrl: redirectUrlFromProps,
}: {
  redirectUrl?: string;
}) => {
  const [isShowLogin, setIsShowLogin] = useState(true);
  const authService = useService(AuthService);
  const globalDialogService = useService(GlobalDialogService);
  const loginStatus = useLiveData(authService.session.status$);
  const t = useI18n();
  // const navigate = useNavigate();
  // const { jumpToIndex } = useNavigateHelper();
  const [searchParams] = useSearchParams();
  const redirectUrl = redirectUrlFromProps ?? searchParams.get('redirect_uri');

  // const server = searchParams.get('server') ?? undefined;
  const error = searchParams.get('error');

  useEffect(() => {
    if (error) {
      notify.error({
        title: t['com.affine.auth.toast.title.failed'](),
        message: error,
      });
    }
  }, [error, t]);
  useEffect(() => {
    if (loginStatus === 'authenticated') {
      setIsShowLogin(false);
      window.location.href = '/';
    }
  }, [loginStatus]);

  // const handleClose = useCallback(() => {
  //   jumpToIndex(RouteLogic.REPLACE, {
  //     search: searchParams.toString(),
  //   });
  // }, [jumpToIndex, searchParams]);
  const getGoogleConfig = () => {
    return {
      clientId: LoginConfig.google.clientId,
      redirectUri: LoginConfig.google.redirectUri,
      loginUri: LoginConfig.google.loginUri,
      scope: LoginConfig.google.scope,
      state: LoginConfig.google.getState(redirectUrl || '/'),
    };
  };
  const getAppleConfig = () => {
    return {
      clientId: LoginConfig.apple.clientId,
      redirectUri: LoginConfig.apple.redirectUri,
      loginUri: LoginConfig.apple.loginUri,
      scope: LoginConfig.apple.scope,
      state: LoginConfig.apple.getState(redirectUrl || '/'),
      response_type: LoginConfig.apple.response_type,
      response_mode: LoginConfig.apple.response_mode,
    };
  };
  const getLoginCode = async (email: string) => {
    console.log('aaaaaaagetLoginCode', email);
    const res = await authService.getLoginCode(email);
    return res;
  };
  const handleReport = async ({
    email,
    code,
  }: {
    email: string;
    code: string;
  }) => {
    // 登录-点击-email
    Tracker.track(EventKeyMap.signin_click, {
      platform: 'email',
    });

    const res = await authService.signInEmail({ email, code });

    if (res?.checkStatus) {
      await authService.session.account$.waitFor(account => !!account);

      loginSuccessTrack(EventKeyMap.login_success, {
        platform: 'email',
      }).then(() => {
        window.location.href = '/';
      });

    } else if (res.checkStatus !== undefined && !res.checkStatus) {
      globalDialogService.open('invitation-code', {
        onSuccess: () => {
          loginSuccessTrack(EventKeyMap.signup_success,{
            platform: 'email',
          }).then(() => {
            window.location.href = '/';
          });
        },
        onFailed: () => {
          Tracker.track(EventKeyMap.signin_error, {
            platform: 'email',
          });
        },
        localStorageKey: 'email_login_user',
      });
    }
    return res.res;
  };

  // const handleAuthenticated = useCallback(
  //   (status: AuthSessionStatus) => {
  //     if (status === 'authenticated') {
  //       if (redirectUrl) {
  //         if (redirectUrl.toUpperCase() === 'CLOSE_POPUP') {
  //           window.close();
  //         }
  //         navigate(redirectUrl, {
  //           replace: true,
  //         });
  //       } else {
  //         handleClose();
  //       }
  //     }
  //   },
  //   [handleClose, navigate, redirectUrl]
  // );

  // const initStep = server ? 'addSelfhosted' : 'signIn';

  // 埋点-登录
  const handleClickAuthButton = (platform: string) => {
    Tracker.track(EventKeyMap.signin_click, {
      platform: platform || '',
    });
  };

  return (
    <LoginWrapper
      leftImage="https://wy-static.wenxiaobai.com/wenxiaobai-web/web-image/muset/loginImage.png"
      loginTitle={t['com.affine.sign.title']()}
      googleLoginConfig={getGoogleConfig()}
      appleLoginConfig={getAppleConfig()}
      termsOfServiceUrl={`${window.location.origin}/terms-of-user`}
      privacyPolicyUrl={`${window.location.origin}/privacy-terms`}
      agreementpreText={t['com.affine.sign.agreementpreText']()}
      termsText={t['com.affine.sign.termsOfService']()}
      privacyText={t['com.affine.sign.privacyPolicy']()}
      andText={t['com.affine.sign.agreement.and']()}
      orLineText={t['com.affine.sign.agreement.or']()}
      isShowLogin={isShowLogin}
      hideCloseIcon={true}
      onClose={() => {
        setIsShowLogin(false);
      }}
      googleLoginButtonText={t['com.affine.sign.google']()}
      appleLoginButtonText={t['com.affine.sign.apple']()}
      needEmailLogin={true}
      emailPlace={t['com.affine.auth.sign.email.placeholder']()}
      codePlace={t['com.affine.auth.sign.email.code.placeholder']()}
      getCodeButtonText={t['com.affine.auth.sign.email.code.get']()}
      retryGetCodeButtonText={t['com.affine.auth.sign.email.code.retry']()}
      hasSendCodeMessageText={`${t['com.affine.auth.sign.email.code.resend']()}`}
      submitButtonText={t['com.affine.auth.sign.email.submit']()}
      getLoginCode={getLoginCode}
      handleReport={handleReport}
      loginErrorText={t['com.affine.auth.sign.email.code.invalid']()}
      emailErrorText={t['com.affine.auth.sign.email.invalid']()}
      onClickAuthButton={handleClickAuthButton}
    />
  );
};

export const Component = () => {
  return (
    <AffineOtherPageLayout>
      <SignInBackgroundArts />
      <SignIn />
    </AffineOtherPageLayout>
  );
};
